import { useState } from 'react';

import type { FormState } from '../../types';

const useFormState = <T extends string>() =>
  useState<FormState<T>>({
    loading: false,
    submitted: false,
  });

export default useFormState;
